import * as React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LoadingModal from "../components/modals/LoadingModal";
import NotificationSnackbar from "../components/NotificationSnackbar";
import CustomerSelect from "../components/CustomerSelect";
import EvaluationSelect from "../components/EvaluationSelect";
import BenchmarkResults from "../components/BenchmarkResults";
import { useTranslation } from "react-i18next";
import { CGI_BLACK } from "../helpers/enums";
import { Box, Button, Container, Typography } from "@mui/material";

export default function Benchmark() {
  const { t } = useTranslation();

  const [selectedCustomer, setSelectedCustomer] = React.useState("");

  const [openNotification, setOpenNotification] = React.useState(false);
  const [notificationMessage, setNotificationMessage] = React.useState("");
  const [openLoading, setOpenLoading] = React.useState(false);

  const [selectedModule, setSelectedModule] = React.useState("");
  const [selectedEvaluation, setSelectedEvaluation] = React.useState("");

  const error = console.error;
  console.error = (...args) => {
    if (/defaultProps/.test(args[0])) return;
    error(...args);
  };

  const [secondEvaluation, setSecondEvaluation] = React.useState("");

  return (
    <>
      <Container maxWidth="xl">
        {selectedCustomer === "" ? (
          <CustomerSelect
            setSelectedCustomer={setSelectedCustomer}
            setNotificationMessage={setNotificationMessage}
            setOpenNotification={setOpenNotification}
            setOpenLoading={setOpenLoading}
            title={t("benchmarkSelectCustomer")}
          />
        ) : (
          <React.Fragment>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                mt: 2,
                borderBottom: 1,
                borderColor: CGI_BLACK,
              }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => {
                  if (selectedEvaluation !== "") {
                    setSelectedEvaluation("");
                    setSecondEvaluation("");
                    setSelectedModule("");
                  } else {
                    setSelectedCustomer("");
                  }
                }}
                sx={{ width: 330, border: 0 }}
              >
                {selectedEvaluation === ""
                  ? t("backToCustomerSelection")
                  : t("backToEvalSelection")}
              </Button>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ ml: 3, fontSize: 16, fontWeight: 500 }}>
                  {t("customer")} {selectedCustomer.name}
                  {selectedCustomer.versionNumber &&
                    " - " + selectedCustomer.versionNumber}
                </Typography>
                {selectedEvaluation !== "" && (
                  <React.Fragment>
                    <Typography
                      sx={{ fontSize: 16, ml: 2, pl: 2, borderLeft: 1 }}
                    >
                      {selectedModule.name || selectedModule.title} (
                      {selectedModule.package})
                    </Typography>
                    <Typography
                      sx={{ fontSize: 16, ml: 2, pl: 2, borderLeft: 1 }}
                    >
                      {t("evaluationFrom")}{" "}
                      {new Date(selectedEvaluation.createdAt).toLocaleString(
                        t("timeSettings"),
                        {
                          timeZone: "Europe/Berlin",
                        }
                      )}
                    </Typography>
                  </React.Fragment>
                )}
              </Box>
            </Box>
            {selectedEvaluation === "" && (
              <EvaluationSelect
                selectedCustomer={selectedCustomer}
                setNotificationMessage={setNotificationMessage}
                setOpenNotification={setOpenNotification}
                setOpenLoading={setOpenLoading}
                setSelectedEvaluation={setSelectedEvaluation}
                setSelectedModule={setSelectedModule}
                generationOptions={false}
              />
            )}
            {selectedEvaluation !== "" && (
              <BenchmarkResults
                selectedModule={selectedModule}
                selectedEvaluation={selectedEvaluation}
                setNotificationMessage={setNotificationMessage}
                setOpenNotification={setOpenNotification}
                setOpenLoading={setOpenLoading}
                secondEvaluation={secondEvaluation}
                setSecondEvaluation={setSecondEvaluation}
              />
            )}
          </React.Fragment>
        )}
      </Container>
      <LoadingModal open={openLoading} />
      <NotificationSnackbar
        message={notificationMessage}
        open={openNotification}
        setOpen={setOpenNotification}
      />
    </>
  );
}
